<template>
  <div class="home">
    <StatsDisplay />
  </div>
</template>

<script>
import StatsDisplay from '@/components/MobileStatsDisplay.vue'

export default {
  name: 'HomeView',
  components: {
    StatsDisplay
  }
}
</script>